import { useAtomValue } from 'jotai';

import { Box, Button, Group, Stack } from '@ekhodealer/ekho-common/rev';

import { useGetLeadDetails } from '@common/api/leads/useGetLeadDetails';
import { InfoLineItem } from '@common/components/InfoLineItem';
import { StatBox } from '@common/components/StatBox';

import { leadDetailsDrawerAtom } from '../../atoms/leadDetailsDrawerAtoms';
import { StageDropdown } from '../StageDropdown';
import { PipelineCell } from '../table-cells/PipelineCell';
import { TypeCell } from '../table-cells/TypeCell';

/**
 * Summary section for lead details
 * Displays key metrics and lead information at the top of the overview tab
 */
export const SummarySection = () => {
	const { selectedRow: lead } = useAtomValue(leadDetailsDrawerAtom);
	const { data: leadDetails } = useGetLeadDetails(lead?.id);

	if (!lead) {
		return null;
	}

	return (
		<Stack itemsSpacing='16'>
			{/* Stats Row */}
			<Group itemsSpacing='12' noWrap itemsAlignX='stretch'>
				<StatBox
					title='Cart total'
					detail={leadDetails?.summary.cartTotal || lead.dealAmount}
				/>
				<StatBox
					title='Lead created'
					detail={leadDetails?.summary.dateCreated || lead.dateCreated}
				/>
				<StatBox
					title='Latest activity'
					detail={leadDetails?.summary.recentActivity || lead.lastUpdated}
				/>
			</Group>

			{/* Details Box */}
			<Box rounding='12' background='secondary' padding='16'>
				<Stack itemsSpacing='12'>
					{/* Pipeline Row */}
					<InfoLineItem
						title='Pipeline'
						content={<PipelineCell pipeline={lead.pipeline} />}
					/>

					{/* Stage Row */}
					<InfoLineItem title='Stage' content={<StageDropdown item={lead} />} />

					{/* Type Row */}
					<InfoLineItem title='Type' content={<TypeCell type={lead.type} />} />
				</Stack>
			</Box>

			{/* Action Buttons */}
			<Group itemsSpacing='8' noWrap itemsAlignX='start'>
				<Button
					variant='filled'
					size='medium'
					onPress={() => {
						if (leadDetails?.contactInfo.phone) {
							window.location.href = `tel:${leadDetails.contactInfo.phone}`;
						}
					}}
					isDisabled={!leadDetails?.contactInfo.phone}>
					Call now
				</Button>
				<Button
					variant='outline'
					size='medium'
					onPress={() => {
						if (leadDetails?.contactInfo.email) {
							window.location.href = `mailto:${leadDetails.contactInfo.email}`;
						}
					}}
					isDisabled={!leadDetails?.contactInfo.email}>
					Send follow-up email
				</Button>
			</Group>
		</Stack>
	);
};
